<template>
    <div>
        <!-- 表头 -->
        <van-sticky offset-top="1.0558rem">
            <div class="boxTitle">
                <van-row type="flex" justify="center" align="center">
                <van-col span="2" align="center">序号</van-col>
                <van-col span="6" align="center">商品</van-col>
                <van-col span="8" align="center">本期</van-col>
                <van-col span="4" align="center">{{handCheckConfig('isGoods', 'name')}}</van-col>
                <van-col span="3" align="center">环比%</van-col>
                </van-row>
            </div>
        </van-sticky>

        <div class="table">
            <van-card v-for="items in stationList" :key="items.value">
              <template #title>
                <div class="title" :id="items.value">
                    <div style="display: flex;justify-content: space-between;width:99%;white-space: break-spaces">
                        <div style="flex: 1;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{items.text}}</div>
                        <div v-if="items.stateName.indexOf('退回') > -1" :style="{color: items.stateName.indexOf('待审核') > -1 ? 'blue' : (items.stateName.indexOf('已审核') > -1 ? 'green' : 'red'), width: '2.8rem',textAlign:'right',fontSize:'14px'}">{{items.stateName}}</div>
                    </div>
                    <van-divider style="margin:0;color:#2f2f2f"/>
                </div>
              </template>
              <template #desc >
                <van-list v-model="loading"
                          :finished="finished"
                          finished-text=""
                          @load="onLoad"
                          style="padding-bottom: 0.2rem"
                          >
                  <div :style="{backgroundColor: color[item.rowNumber]}"
                    :class="[index % 2 == 0 ? 'even' : 'odd']"
                      v-for="(item,index) in list"
                      :key="index">
                      <div v-if="item.StationCode === items.value">
                        <van-row type="flex"
                            justify="center"
                            align="center">
                      <van-col span="2"
                              align="center">
                        <div style="width: 50%;background-color: red;color:#fff" v-if="!item.isGoods && ((item.itemNumbersShow && !item.itemNumbers) || (item.originBrandShow && !item.originBrand))">
                            {{ index + 1 }}
                        </div>
                        <div v-else-if="item.isGoods || (!item.itemNumbersShow && !item.originBrandShow)">
                            {{ index + 1 }}
                        </div>
                        <div v-else  style="width: 50%;background-color: green;color:#fff">
                          {{ index + 1 }}
                        </div>
                      </van-col>
                      <van-col
                        span="6"
                        :style="{
                            color:
                            item.VarietyCodeNew ==item.VarietyCode || item.isGoods == 1 ||
                            (item.ThisPrice == 0 && item.ThisPrice !== '')  ||
                            (item.hbzks !== null && item.hbNum >= item.hbzks && item.hbNum > 0) ||
                            (item.hbjks !== null && Math.abs(item.hbNum) >= item.hbjks && item.hbNum < 0) ||
                            (item.dqbb && (parseFloat(item.sameNumPrice) == parseFloat(item.ThisPrice)) && item.sameNum + ((parseFloat(item.sameNumPrice) == parseFloat(item.ThisPrice)) ? 1 : 0) >= item.dqbb)
                            ? 'red'
                            :'blue'
                        } "
                              class="contentLimit"
                              @click="clickStoreName(item,index)">{{item.VarietyName}}--{{item.StandardName}}--{{item.TargetName}}</van-col>
                      <van-col span="1"
                              align="center">&emsp;</van-col>
                      <van-col span="9">
                        <div class="input">
                                <input
                                    v-model="item.ThisPrice"
                                    :class="{ bianhui: saveState || item.isGoods == 1}"
                                    @blur="changePrice(index)"
                                    type="number"
                                    :style="{
                                        background:
                                        (item.ThisPrice == 0 && item.ThisPrice !== '') || saveState || item.isGoods == 1
                                            ? '#efe7e7'
                                            : '',
                                    }"
                                    oninput="if(value<0)value=0; if(value>99999999999999)value=99999999999999"
                                    :min="item.goods_minimum || 0"
                                    :max="item.goods_maximum || 99999999999999"
                                    required
                                />
                        </div>
                        {{item.UnitName}}
                      </van-col>
                      <van-col span="2"
                              align="right">
                        <van-checkbox v-model="item.isGoods" icon-size="0.42rem" shape="square" class="import" @change="changeIsGoods(item, index)" :disabled="saveState"></van-checkbox>
                      </van-col>
                      <!-- 环比：（本期数-上期数）/上期数×100% -->
                      <van-col span="3"
                              align="right"
                              :style="{ color: item.styleColor }"
                              v-model="item.hbNum">{{item.hbNum}}</van-col>
                      <van-col span="1"
                              align="center">&emsp;</van-col>
                    </van-row>
                      </div>
                  </div>
                </van-list>
                <div style="height:1rem;background-color:#f0f2f1" v-if="lastStation == items.value" ></div>
              </template>
            </van-card>
        </div>
    </div>
</template>
<script>
import { Toast } from 'vant'
export default {
    props: {
        list:{
            type: Array,
            default: () => {
                return [];
            }
        },
        stationList:{
            type: Array,
            default: () => {
                return [];
            }
        },
        saveState: {
            type: Boolean,
            default: false
        },
        lastStation: {
            type: String,
            default: ''
        },
        taskConfig: {
            type: Array,
            default: () => {
                return [];
            }
        }
    },
    watch: {

    },
    data() {
        return {
            loading:false,
            finished:false,
            color: ['#f2fbfe', '#e0f7ff']
        };
    },
    methods: {
        onLoad() {
            setTimeout(() => {
                this.loading = false;
                this.finished = true;
            }, 1000)
        },
        // 判断是否显示红色序号------有必填的拓展字段未填
        handComputeIfshow(row) {
            let ifShow = false
            if(!row.list) {
                return false
            }
            row.list.forEach(i=> {
                if((row[i.fieldName] == '' || !row[i.fieldName])  && i.ifMust == 1) {
                return ifShow = true
                }
            })
            return ifShow
        },
        // 点击商品显示弹框
        clickStoreName(item, index) {
            this.$emit('handItemCLick', item, index)
        },
         //环比实时变化
        changePrice(i) {
            let hbNum;
            let ringPrice = this.list[i].ringPrice; //上期 ringPrice
            let thisPrice = this.list[i].ThisPrice; //本期 ThisPrice
            //report_digits
            if (!Number(thisPrice) || thisPrice == "") {
                this.list[i].hbNum = "-";
                return;
            }
            if (thisPrice.split(".").length - 1 > 1) {
                Toast("本期价格输入格式不正确请重新输入!");
                return;
            }
            thisPrice = parseFloat(thisPrice).toFixed(this.list[i].report_digits);
            this.list[i].ThisPrice = thisPrice;
            if (!Number(ringPrice) || ringPrice == 0) {
                this.list[i].hbNum = "-";
                return;
            }
            ringPrice = parseFloat(ringPrice);
            thisPrice = parseFloat(thisPrice);
            hbNum = ((thisPrice - ringPrice) / ringPrice) * 100;
            if (hbNum == Infinity || isNaN(hbNum)) {
                this.list[i].hbNum = "-";
            } else {
                if (hbNum > 0) {
                this.list[i].styleColor = "red";
                } else if (hbNum < 0) {
                this.list[i].styleColor = "green";
                } else {
                this.list[i].styleColor = "black";
                }
                if (
                hbNum.toString().indexOf(".") != -1 &&
                hbNum.toString().split(".")[1].length > 2
                ) {
                hbNum = hbNum.toFixed(2);
                }
                this.list[i].hbNum = hbNum;
            }
        },
        // 无此品种点击
        changeIsGoods(item, i) {
            // console.log(item)
            this.list.forEach((a, b) => {
                if(a.pzCode == item.pzCode && a.StationCode == item.StationCode) {
                    this.list[b].isGoods = this.list[i].isGoods
                    this.list[b].ThisPrice = this.list[b].isGoods ? 0 : ''
                    this.list[b].Memo = this.list[b].isGoods ? '无此品种' : ''
                    this.list[b].isGoods = this.list[b].isGoods ? 1 : 0
                    this.list[b].hbNum = '-'
                    // console.log(this.list[b])
                }
            })

        },

        // 动态列
        handCheckConfig(str, val) {
            let result = "";
            this.taskConfig.forEach((i) => {
                if (i.displayColumnValue == str && val == "show") {
                result = i.isDisplay;
                }
                if (i.displayColumnValue == str && val == "name") {
                result = i.autoColumn ? i.autoColumn : i.displayColumnName;
                }
                if (i.displayColumnValue == str && val == "width") {
                result = i.widthColumn;
                }
            });
            return result;
        },


    }
}
</script>
<style lang="scss" scoped>
.boxTitle {
    height: 1rem;
    line-height: 1rem;
    background-color: #4494f3;
    color: #ffffff;
    font-size: px2rem(36);
}
.table {
    height: calc(100% - 5.7158rem);
    .title{
      height: 30px;
      font-size: 16px;
      // color: #4494f3;
      color: #000;
      background-color: #ffffff;
      line-height: 30px;
      text-indent: 1em;
      display: inline-block;
      white-space: nowrap;
      width: 100%;
      overflow: hidden;
      text-overflow:ellipsis;
    }
    /deep/.van-card {
      padding: 0;
    }
    .input {
      display: inline-block;
      vertical-align: middle;
      width: 2.2rem;
      background-color: #fff;
      border: px2rem(1) solid #4494f3;
      input {
        margin: 0;
        border: 0;
        height: 0.8rem;
        vertical-align: middle;
        width: 2.2rem;
        outline: none;
        text-align: left;
      }
    }
    .even {
      display: flex;
      font-size: px2rem(36);
    //   background-color: #f2fbfe;
      color: #3e3e3e;
      /deep/.van-row {
        width: 100vw;
        height: 50px;
      }
    }
    .odd {
      display: flex;
      font-size: px2rem(36);
    //   background-color: #e0f7ff;
      color: #3e3e3e;
      /deep/.van-row {
        width: 100vw;
        height: 50px;
      }
    }
    .contentLimit {
      //表格内容商品列限制三行展示
      word-break: break-all;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
      //审核过的事项 底部按钮变灰
    .bianhui {
        pointer-events: none;
        filter: grayscale(1);
        .btn1 {
        font-weight: 400;
        color: #ababab;
        }
    }
    /deep/.van-checkbox__icon .van-icon {
        border: 1px solid #3e3e3e;
    }
    /deep/.van-checkbox--disabled .van-checkbox__icon .van-icon {
        border: 1px solid #c8c9cc;
    }
    .import {
        .van-checkbox .van-checkbox__icon {
            height: 0.42rem !important;
            line-height: 0.42rem !important;
            width: 0.42rem !important
        }
    }
}
</style>